<template>
  <div class="three-point-light"></div>
</template>

<script>
import { PointLight, SphereGeometry, MeshLambertMaterial, Mesh } from 'three'
import Object3DMixin from '@/components/threejs/objects/Object3DMixin'

export default {
  name: 'ThreePointLight',
  mixins: [Object3DMixin],
  created () {
    const light = new PointLight(this.node.colour, this.node.intensity, 0)
    this.light = light
    light.castShadow = true
    this.object3d.add(light)

    // Add a sphere object to represent the light
    const geometry = new SphereGeometry(0.5, 32, 32)
    const material = new MeshLambertMaterial({ color: '#fff', emissive: this.node.colour })
    this.material = material
    const sphere = new Mesh(geometry, material)
    this.object3d.add(sphere)
    this.$emit('loaded', this.node)
  },
  computed: {
    colour () {
      return this.node.colour
    },
    intensity () {
      return this.node.intensity
    }
  },
  watch: {
    colour (newColour, oldColour) {
      if (newColour !== oldColour) {
        this.light.color.set(newColour)
        this.material.emissive.set(newColour)
      }
    },
    intensity (intensity) {
      this.light.intensity = intensity
    }
  }
}
</script>

<style>

</style>
